@if (isOpen) {
<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- modal backdrop dismiss pattern -->
<div class="modal-overlay" [class.show]="isOpen" (click)="onBackdropClick($event)" (keydown.escape)="onClose()">
  <div class="modal-container" [class.expanded]="isModalExpanded()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="title-section">
        <h2>{{ entityData?.name }}</h2>
      </div>
      <div class="header-controls">
        <button class="close-btn" (click)="onClose()" type="button">
          <span>×</span>
        </button>
        <button class="expand-btn" (click)="toggleModalSize()" type="button">
          <span>{{ isModalExpanded() ? '⤢' : '⤡' }}</span>
        </button>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="stats-table-container">
        <table class="stats-table" aria-describedby="stats-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr class="stats-row">
              <td class="category">Entities</td>
              <td class="count">{{ entityData?.totalEntities || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Resigned Entities</td>
              <td class="count">{{ entityData?.totalResignedEntities || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Invoices</td>
              <td class="count">{{ entityData?.totalInvoices || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Share Classes</td>
              <td class="count">{{ entityData?.totalShareClasses || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Bank Accounts</td>
              <td class="count">{{ entityData?.totalBankAccounts || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Investments</td>
              <td class="count">{{ entityData?.totalInvestments || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Assets</td>
              <td class="count">{{ entityData?.totalAssets || 0 }}</td>
            </tr>
            <tr class="stats-row">
              <td class="category">Loans</td>
              <td class="count">{{ entityData?.totalLoans || 0 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onClose()">Close</button>
    </div>
  </div>
</div>
}
